module.exports = __webpack_public_path__ + "static/media/ImgMBTI_ROTA.7f89bd62.png";